import { render } from "./DepositPeriodCountdown.vue?vue&type=template&id=a795a666"
import script from "./DepositPeriodCountdown.vue?vue&type=script&lang=js"
export * from "./DepositPeriodCountdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_8601aa9edf40feba5c1f16c508af6bdf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__